// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3fa6e7fc] .ant-radio-group {\n  padding-right: 20px;\n}", ""]);
// Exports
module.exports = exports;
